import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Sun.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "SunIcon";
const s = e;
export {
  s as Sun,
  e as SunIcon
};
